import { SVGProps, Ref, forwardRef } from 'react';

export const ImageFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 2.375 2.375 1 12 1s11 1.375 11 11c0 1.842-.05 3.382-.2 4.668l-5.329-4.401-3.652 2.87-5.468-4.29-7.15 5.829C1.05 15.388 1 13.846 1 12m.576 6.691C2.602 22.335 5.306 23 12 23c6.695 0 9.398-.665 10.424-4.309l-4.98-4.113-3.624 2.848-5.447-4.274zM13.75 7.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75"
                fill="currentColor"
            />
        </g>
    </svg>
));
ImageFilledSize24Glyph.displayName = 'ImageFilledSize24Glyph';
